(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rednib-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('rednib-newsletter-consent-template');
  const labels = document.getElementById('rednib-newsletter-labels');
  if (!template || !labels) return;
  const update = () => {
    document.querySelectorAll('form.rmBase__content:not([data-rednib-reviewed])').forEach((form) => {
      form.dataset.rednibReviewed = 'true';
      form.querySelectorAll('.rmBase__el--label-pos-none').forEach((element) => element.classList.remove('rmBase__el--label-pos-none'));
      form.querySelectorAll('.rmBase__compLabel--hideable').forEach((element) => element.classList.remove('rmBase__compLabel--hideable'));
      const privacy = form.querySelector('.privacy__text');
      if (privacy) privacy.replaceChildren(template.content.cloneNode(true));
      const email = form.querySelector('input[name="email"]');
      if (email) {
        email.type = 'email';
        email.required = true;
        email.autocomplete = 'email';
      }
      [['firstname', labels.dataset.first, 'given-name'], ['lastname', labels.dataset.last, 'family-name']].forEach(([name, text, autocomplete]) => {
        const input = form.querySelector('input[name="' + name + '"]');
        if (!input) return;
        input.required = false;
        input.autocomplete = autocomplete;
        const label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.textContent = text;
      });
    });
  };
  update();
  new MutationObserver(update).observe(document.body, {childList: true, subtree: true});
})();
  } catch(e) { console.error(e); }
})();

})();
